import React, { useState, useEffect, useContext, Component } from 'react';
 import Header from '../../components/Header';
import Footer from '../../components/Footer';

const TestingHospitalList = () => {

    return (
        <>
            <Header />

            <main className="page">
 
 <section className="container py-4">

  {/* ✅ TOP FILTER BAR (Latest UI) */}
  <div className="glassbar p-3 mb-4">
    <div className="row g-3 align-items-center">

      {/* Search */}
      <div className="col-lg-4">
        <div className="pill-search d-flex align-items-center gap-2">
          <span className="text-muted">🔎</span>
          <input
            className="form-control border-0 bg-transparent p-0"
            placeholder="Search hospital, clinic, city…"
          />
        </div>
 
      </div>

      {/* City */}
      <div className="col-lg-2">
        <select className="form-select">
          <option>City</option>
          <option>Delhi</option>
          <option>Ghaziabad</option>
          <option>Noida</option>
          <option>Gurgaon</option>
        </select>
      </div>

      {/* Specialty */}
      <div className="col-lg-2">
        <select className="form-select">
          <option>Specialty</option>
          <option>Dental</option>
          <option>Cardiology</option>
          <option>Orthopedic</option>
          <option>Skin</option>
        </select>
      </div>

      {/* Sort */}
      <div className="col-lg-2">
        <select className="form-select">
          <option>Sort: Recommended</option>
          <option>Rating: High → Low</option>
          <option>Nearest First</option>
          <option>Most Reviewed</option>
        </select>
      </div>

      {/* More Filters */}
      <div className="col-lg-2 d-grid">
        <button
          className="btn btn-primary"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#hospitalFilters"
        >
          More Filters
        </button>
      </div>

      {/* Quick chips */}
      <div className="col-12">
        <div className="d-flex gap-2 flex-wrap">
          <button className="chip active" type="button">All</button>
          <button className="chip" type="button">Open Now</button>
          <button className="chip" type="button">Top Rated</button>
          <button className="chip" type="button">Near Me</button>
          <button className="chip" type="button">24x7</button>
          <button className="chip" type="button">Insurance</button>
        </div>
      </div>

      {/* Result info */}
      <div className="col-12">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="small text-muted">
            Showing <b>6</b> Clinics near you
          </div>
          <div className="d-flex gap-2 flex-wrap align-items-center">
            <span className="chip active">City: Ghaziabad ✕</span>
            <span className="chip active">Open Now ✕</span>
            <button className="btn btn-link p-0 text-decoration-none small">Clear all</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  {/* ✅ HOSPITAL CARDS GRID (6 Cards) */}
  <div className="row g-4">

    {[
      {
        name:"Dental Park Clinic",
        rating:"4.9",
        reviews:"(250+)",
        addr:"Raj Nagar, Ghaziabad",
        km:"2.4 km",
        open:true,
        tags:["Dental","Implants","Aligners","RCT"]
      },
      {
        name:"City Smile Care",
        rating:"4.7",
        reviews:"(180+)",
        addr:"Indirapuram, Ghaziabad",
        km:"4.1 km",
        open:true,
        tags:["Dental","Kids","Braces","Cleaning"]
      },
      {
        name:"Elite Multi-Speciality",
        rating:"4.6",
        reviews:"(320+)",
        addr:"Kaushambi, Ghaziabad",
        km:"5.8 km",
        open:false,
        tags:["Dental","ENT","General","Diagnostics"]
      },
      {
        name:"Prime Dental & Aesthetics",
        rating:"4.8",
        reviews:"(210+)",
        addr:"Vasundhara, Ghaziabad",
        km:"3.6 km",
        open:true,
        tags:["Cosmetic","Veneers","Whitening","Aligners"]
      },
      {
        name:"CarePlus Clinic",
        rating:"4.5",
        reviews:"(500+)",
        addr:"Sector 62, Noida",
        km:"7.2 km",
        open:true,
        tags:["Dental","Ortho","Surgery","X-Ray"]
      },
      {
        name:"Apollo Style Clinic",
        rating:"4.9",
        reviews:"(900+)",
        addr:"Gurgaon",
        km:"18 km",
        open:true,
        tags:["Dental","Implants","Laser","Smile Design"]
      },
    ].map((h, idx) => (
      <div className="col-lg-4 col-md-6" key={idx}>
        <div className="hospital-card h-100">

          {/* Image */}
          <div className="thumb d-flex align-items-center justify-content-center overflow-hidden">
 <img src="https://smilewide.in/wp-content/uploads/2021/12/dental-clinic-interior.jpg" />
           </div>

          <div className="p-4">

            {/* Title + Open */}
            <div className="d-flex align-items-start justify-content-between gap-2">
              <div>
                <h6 className="fw-bold mb-1" style={{color:"var(--navy)"}}>
                  {h.name}
                </h6>
                <div className="mini">
                  📍 {h.addr} • <b>{h.km}</b>
                </div>
              </div>

              <span className={`open-pill ${h.open ? "bg-success-subtle text-success border border-success-subtle" : "bg-danger-subtle text-danger border border-danger-subtle"}`}>
                <span className="dot" style={{background: h.open ? "#198754" : "#dc3545"}}></span>
                {h.open ? "Open Now" : "Closed"}
              </span>
            </div>

            {/* Rating */}
            <div className="d-flex align-items-center gap-2 mt-3">
              <span className="badge bg-primary-subtle text-primary rounded-pill">
                ★ {h.rating}
              </span>
              <span className="small text-muted">{h.reviews}</span>
              <span className="badge bg-light text-dark border rounded-pill">
                Verified
              </span>
            </div>

            {/* Services/Tags */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              {h.tags.map((t, i) => (
                <span className="tag" key={i}>✓ {t}</span>
              ))}
            </div>

            {/* CTA */}
            <div className="d-flex gap-2 mt-4">
              <button className="btn btn-outline-primary w-50 rounded-pill">
                View Details
              </button>
              <button className="btn btn-primary w-50 rounded-pill">
                Book Appointment →
              </button>
            </div>

          </div>
        </div>
      </div>
    ))}

  </div>

  {/* ✅ OFFCANVAS FILTERS */}
  <div className="offcanvas offcanvas-end" tabIndex="-1" id="hospitalFilters">
    <div className="offcanvas-header">
      <h5 className="offcanvas-title fw-bold">Refine Clinics</h5>
      <button type="button" className="btn-close" data-bs-dismiss="offcanvas" />
    </div>

    <div className="offcanvas-body">

      <div className="mb-3">
        <label className="form-label fw-semibold">City</label>
        <select className="form-select">
          <option>All</option>
          <option>Delhi</option>
          <option>Ghaziabad</option>
          <option>Noida</option>
          <option>Gurgaon</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Type</label>
        <div className="d-flex flex-wrap gap-2">
           <button className="chip active" type="button">Clinic</button>
          <button className="chip" type="button">Multi-speciality</button>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Availability</label>
        <div className="d-flex flex-wrap gap-2">
          <button className="chip active" type="button">Open Now</button>
          <button className="chip" type="button">24x7</button>
          <button className="chip" type="button">Today Slots</button>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Rating</label>
        <select className="form-select">
          <option>Any</option>
          <option>4.5+</option>
          <option>4.7+</option>
          <option>4.9+</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Facilities</label>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="f1" />
          <label className="form-check-label" htmlFor="f1">Parking</label>
        </div>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="f2" />
          <label className="form-check-label" htmlFor="f2">Insurance</label>
        </div>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="f3" />
          <label className="form-check-label" htmlFor="f3">Wheelchair Access</label>
        </div>
      </div>

      <div className="d-grid gap-2 mt-4">
        <button className="btn btn-primary fw-semibold">Apply Filters</button>
        <button className="btn btn-outline-secondary">Reset</button>
      </div>

    </div>
  </div>

</section>
 

</main>



           
            <Footer />
        </>

    );
};

export default TestingHospitalList